
































































import { Vue, Component, Prop } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { QuillEditor } from '@/common/interface';

import getActivityType from '@/common/utils/getActivityType';
import { isMobile } from '@/common/utils/getPlaform';
import { getInputStyle } from '@/common/utils/getStyles';
import { replaceString } from '@/common/utils/dealWithString';

import ActivityLabel from "@/components/common/edit/ActivityLabel.vue";
import ImageUpload from "@/components/common/edit/ImageUpload.vue";
import EditTitleModal from "@/components/common/edit/EditTitleModal.vue"
interface Payload {
  contactInfo: string;
}

@Component({
  components: {
    "activity-label": ActivityLabel,
    "image-upload": ImageUpload,
    "edit-title-modal": EditTitleModal
  }
})
export default class AcceptContactInfo extends Vue {
  @Prop() noContactMethod!: boolean;
  @Getter("contactInfo") getterContactInfo!: string;
  @Getter("contactQrcode") contactQrcode!: string;
  @Getter('section')  section!: any;
  @Getter("version") version!: string;

  

  @Action("changeContactInfo") changeContactInfo!: Function;
  @Action("changeContactQrcode") changeContactQrcode!: Function;
  @Action("changeShowFooter") changeShowFooter!: Function;
  @Getter("contactTitle") contactTitle!: string;
  @Getter("contactSwitch") contactSwitch!: string;


  text!: string;
  getActivityType: Function = getActivityType;
  replaceString: Function = replaceString;
  isMobile: Function = isMobile;
  showTitleModal: boolean = false;

  get inputStyle() {
    const { inputFontColor, inputBackgroundColor } = this.section
    return getInputStyle(inputFontColor, inputBackgroundColor);
  }

  onEditorChange(quill: QuillEditor) {
    const { html, text } = quill;
    // 限制1000个字
    if (text.length > 1000) {
      const quillDom = (this.$refs.contactQuillEditor as any);
      quillDom.quill.setText(this.text);
      return null;
    }
    this.text = text;
    this.changeContactInfo({
      contactInfo: html
    });
  }

  handleChangeQrcodeImage(imgUrl: string) {
    this.changeContactQrcode(imgUrl);
  }

  handleDeleteQrcodeImage() {
    this.changeContactQrcode("");
  }

  handleShowTitleModal(): void {
    this.showTitleModal = true;
    this.changeShowFooter(false);
  }
  handleHideShowTitleModal(): void {
    this.showTitleModal = false;
    this.changeShowFooter(true);
  }
}
